var path = 'areas/projects/actions/Octopus.Email_summary.html';
var html = "<p> Send an email to <a href=\"mailto:{{ properties['Octopus.Action.Email.To'] }}\">{{ properties[\"Octopus.Action.Email.To\"] }}</a> <tag-list tags=emailTeams></tag-list> <span ng-show=\"properties['Octopus.Action.Email.CC'] || properties['Octopus.Action.Email.CCTeamIds'] || properties['Octopus.Action.Email.Bcc'] || properties['Octopus.Action.Email.BccTeamIds']\"> (including CC/BCC)</span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Email_summary.html
// module id = 843
// module chunks = 1